export const STATE_ALL_ON = 'STATE_ON';
export const STATE_ALL_OFF = 'STATE_OFF';
export const STATE_UNDETERMINED = 'STATE_UNDETERMINED';



/** WEBPACK FOOTER **
 ** ./frontend/constants/states.js
 **/